<template>
  <layout-component>
    <div class="container">
      <div class="row form-wrapper pb-4 pb-md-2">
        <div class="col-md-7 col-lg-8 form form-login">
          <h1 class="br-title left-bullet" v-html="$t('title-banner')"></h1>
          <p class="br-title p-intro" v-html="$t('text-01')"></p>
          <div class="row">
            <div class="col-lg-9">

              <b-alert :show="has_error && !success" fade variant="danger">
                <h4><i class="fal fa-times"></i> {{'error-title'|t}}.</h4>
                <p>{{'error-text'|t}}</p>
                <router-link class="link small-link ml-auto" to="/forgot-password">{{'link-forgot'|t}}</router-link>
              </b-alert>


              <form autocomplete="off" @submit.prevent="login" method="post">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="email">{{'email-address'|t}} <span class="required">*</span></label>
                        <div class="input-wrapper">
                          <input type="email" id="email" class="form-control" placeholder="user@example.com" v-model="email" required autocomplete clearInput >
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                        <label for="password">{{'password'|t}}</label>
                        <div class="input-wrapper">
                          <input ref="password" type="password" id="password" class="form-control" v-model="password" required autocomplete clearInput  >
                          <span class="focus-border"></span>
                        </div>
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center pt-2">
                  <button type="submit" class="btn btn-primary mt-0"><span>{{'btn-submit'|t}}</span></button>
                  <router-link class="link small-link ml-auto" to="/forgot-password">{{'link-forgot'|t}}</router-link>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="ml-auto col-md-4 col-lg-3 sidebar-right pt-md-4 pt-3">
          <h3 class="left-bullet" v-html="$t('title-02')"></h3>
          <p class="br-title" v-html="$t('text-02')"></p>
          <router-link class="btn" to="/register"><span>{{'btn-sidebar'|t}}</span></router-link>
        </div>
      </div>

    </div>
	</layout-component>
</template>

<script>
  export default {
    data() {
      return {
        email: null,
        password: null,
        has_error: false,
        success: false,
        redirectTo: null
      }
    },

    mounted() {
      $('.title-anim-wrapper:in-viewport').addClass('in-viewport');

        Vue.axios.get('/auth/user').then( ({data}) => {
            if(data.data){
                this.$router.push('book');
            }
        })
    },

    methods: {
      login() {

        // get the redirect object
        var redirect = this.$auth.redirect();

        var app = this;
        //Fix issue
        app.password = this.$refs.password.value;


        this.$auth.login({
          data: {
            email: app.email,
            password: app.password
          },
          success: function(res) {
            app.has_error = false
            app.success = true
            // handle redirection
            this.redirectTo = redirect ? redirect.from.path : this.$router.back()
            this.$store.user = this.$auth.user()
            this.$store.setLocale(this.$store.user.locale)
            this.$store.loadCart()
            this.$router.push(this.redirectTo)
            this.$store.updateUser(this.$auth.user())
          },
          error: function() {
            app.has_error = true
          },
          rememberMe: true,
          fetchUser: true
        })
      }
    }
  }
</script>


<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Enter the</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Sonotron</span></span>",
        "text-01": "Hey, tune chasers & beat makers. <br/>We’ve missed you. Log in to manage your bookings.",
        "email-address": "Email address",
        "password": "Password",
        "btn-submit": "Login",
        "link-forgot": "Forgot password ?",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim td-3'>New to</span></span> <span class='title-anim-wrapper'><span class='title-anim td-4'>Sonotron?</span></span>",
        "text-02": "Create a Sonotron account to manage all of rehearsal bookings in one place and easily switch between your desktop and mobile. <strong>Unlock the Sonotron universe today</strong>.",
        "btn-sidebar": "Create an account",
        "error-title": "Error",
        "error-text": "Unable to connect with these credentials"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim td'>Entrez dans le</span></span> <span class='title-anim-wrapper'><span class='title-anim td-2'>Sonotron</span></span>",
        "text-01": "Hey, tune chasers & beat makers. <br/>Vous nous avez manqué&nbsp;! Connectez-vous pour gérer vos réservations.",
        "email-address": "Adresse email",
        "password": "Mot de passe",
        "btn-submit": "Se connecter",
        "link-forgot": "Mot de passe oublié ?",
        "title-02": "<span class='title-anim-wrapper'><span class='title-anim td-3'>Premiere fois au</span></span> <span class='title-anim-wrapper'><span class='title-anim td-4'>Sonotron ?</span></span>",
        "text-02": "Créez un compte pour gérer et consulter le détail de vos réservations facilement, sur ordinateur comme sur mobile. <strong>Vous avez l’univers du Sonotron à portée de main</strong>.",
        "btn-sidebar": "Creer un compte",
        "error-title": "Erreur",
        "error-text": "La connexion est impossible avec les données fournies."
      }
    }

  </i18n>
